import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  createStyles,
  Group,
  Title,
  Text,
  Container,
  Avatar,
  ActionIcon,
  Textarea,
  TextInput,
  Grid,
  Card,
  Box,
  Image,
  Button,
  Progress,
} from "@mantine/core";
import { IconBrandLinkedin } from "@tabler/icons-react";
import axios from "../../api/axios";
import { BsPencil } from "react-icons/bs";
import { BsTrash } from "react-icons/bs";

import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

import useAuth from "../../hooks/useAuth";
import QuillResizeImage from "quill-resize-image";
import { CancelButton, SaveButton } from "../buttons/Buttons";
import cloudinaryConfig from "../../config/cloudinary.config";

Quill.register("modules/resize", QuillResizeImage);
const useStyles = createStyles((theme) => ({
  title: {
    [theme.fn.smallerThan("sm")]: {
      fontSize: "24px",
    },
  },

  description: {
    fontWeight: 200,
  },

  cardMain: {
    marginBottom: "80px",
  },
  card: {
    transition: "transform 150ms ease, box-shadow 150ms ease",
    padding: theme.spacing.xl,
    maxWidth: "900px",
    margin: "0 auto",
    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: theme.shadows.md,
    },
  },
  editor: {
    minHeight: "200px",
    height: "300px",
    marginBottom: "80px",
  },

  icon: {
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[3]
        : theme.colors.gray[5],
  },

  name: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    color: "#fff",
    zIndex: 9999,
  },
}));

export default function EditBlogPostLayout() {
  const { classes } = useStyles();
  const languagePrefix = window.location.pathname.startsWith("/nl")
    ? "/nl"
    : window.location.pathname.startsWith("/de")
    ? "/de"
    : "";

  const { post_id } = useParams();
  //   const post = posts.find((post) => post?.id === parseInt(post_id, 10));

  const [post, setPost] = useState({});

  const [editBlog, setEditBlog] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const { auth } = useAuth();
  const [form, setForm] = useState({
    title: "",
    author: "",
    designation: "",
    profileUrl: "",
    userdescription: "",
    usertitle: "",
    userImage: "",
    content: "",
    description: "",
    author_id: 0,
    language: "EN",
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [intervalId, setIntervalId] = useState(null);

  function getBasePath() {
      const path = window.location.pathname;
      const match = path.match(/^(\/resiweb\/[^/]+)/); 
      return match ? match[1] : ""; 
    }

  const startLoading = () => {
    setLoading(true);
    setProgress(0);
    let currentProgress = 0;

    const interval = setInterval(() => {
      const increment = Math.floor(Math.random() * 10) + 5;
      currentProgress += increment;

      if (currentProgress >= 95) {
        currentProgress = 95;
        setProgress(currentProgress);
        clearInterval(interval);
      } else {
        setProgress(currentProgress);
      }
    }, 200);

    setIntervalId(interval);
  };
  const stopLoading = () => {
    if (intervalId) clearInterval(intervalId);
    setProgress(100);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const [userImageFile, setUserImageFile] = useState(null);
  const [userImagePreview, setUserImagePreview] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
  const getBlogs = () => {
      axios
        .get(`/blog/${post_id}`)
        .then(async (res) => {
          setPost(res.data);

          let postData = res.data;
          setTitle(postData.title);
          console.log(postData.title);
          setDescription(postData.description);

          const {
            title,
            content,
            authorUsername,
            language,
            description,
            imageUrl,
            author_id,
          } = postData;

          setForm({
            title,
            content,
            description,
            author: authorUsername,
            language: language || "EN",
            author_id,
            imageUrl,
          });

          const user_response = await axios.get(`/website-user/${author_id}`);

          setForm((prevForm) => ({
            ...prevForm,
            designation: user_response.data?.designation || "",
            profileUrl: user_response.data?.profileUrl || "",
            usertitle: user_response.data?.title || "",
            userdescription: user_response.data?.description || "",
          }));
          if (postData.imageUrl) {
            setImagePreview(postData.imageUrl);
          }
          if (user_response.data?.imageUrl) {
            setUserImagePreview(user_response.data.imageUrl);
          }
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
        });
    };

    getBlogs();
  }, [post_id]);

  const validate = () => {
    const newErrors = {};
    if (!form.title.trim()) {
      newErrors.title = "Title is required.";
    }
    if (!form.description.trim()) {
      newErrors.description = "Description is required.";
    }
    if (!form.usertitle.trim()) {
      newErrors.usertitle = "Author Name is required.";
    }
    if (!form.designation.trim()) {
      newErrors.designation = "Designation is required.";
    }
    // if (!form.author.trim()) {
    //   newErrors.author = "Author is required.";
    // }
    if (!form.content.trim()) {
      newErrors.content = "Content is required.";
    }
    if (!form.language) {
      newErrors.language = "Language is required.";
    }
    return newErrors;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
    if (errors[name])
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
  };

  const handleEditorChange = (data) => {
    setForm((prevForm) => ({ ...prevForm, content: data }));
    if (errors.content)
      setErrors((prevErrors) => ({ ...prevErrors, content: undefined }));
  };

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // Remove selected image
  const removeImage = () => {
    setImageFile(null);
    setImagePreview(null);
  };

  const handleUserImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUserImageFile(file);
      setUserImagePreview(URL.createObjectURL(file));
    }
  };

  const removeUserImage = () => {
    setUserImageFile(null);
    setUserImagePreview(null);
  };

  // console.log(auth)
  // Submit updated blog
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0 && auth) {
      try {
        startLoading();

        let blogImageUrl = null;
        let authorImageUrl = null;

        const generateRandomString = (length = 10) => {
          const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
          return Array.from({ length }, () =>
            chars.charAt(Math.floor(Math.random() * chars.length))
          ).join("");
        };

        // ✅ Upload blog image
        if (imageFile) {
          const blogImgId = generateRandomString();
          const signRes = await axios.get("/signuploadform", {
            params: { folder: auth.username, publicID: blogImgId },
          });

          const blogUploadUrl =
            cloudinaryConfig.BASE_URL +
            signRes.data.cloudName +
            cloudinaryConfig.UPLOAD_SUFFIX;

          const blogFormData = new FormData();
          blogFormData.append("file", imageFile);
          blogFormData.append("api_key", signRes.data.apiKey);
          blogFormData.append("cloud_name", signRes.data.cloudName);
          blogFormData.append("folder", auth.username);
          blogFormData.append("public_id", blogImgId);
          blogFormData.append("signature", signRes.data.signature);
          blogFormData.append("timestamp", signRes.data.timestamp);

          const res = await axios.post(blogUploadUrl, blogFormData);
          blogImageUrl = res.data.secure_url;
        }

        // ✅ Upload author image
        if (userImageFile) {
          const authorImgId = generateRandomString();
          const signRes = await axios.get("/signuploadform", {
            params: { folder: auth.username, publicID: authorImgId },
          });

          const authorUploadUrl =
            cloudinaryConfig.BASE_URL +
            signRes.data.cloudName +
            cloudinaryConfig.UPLOAD_SUFFIX;

          const authorFormData = new FormData();
          authorFormData.append("file", userImageFile);
          authorFormData.append("api_key", signRes.data.apiKey);
          authorFormData.append("cloud_name", signRes.data.cloudName);
          authorFormData.append("folder", auth.username);
          authorFormData.append("public_id", authorImgId);
          authorFormData.append("signature", signRes.data.signature);
          authorFormData.append("timestamp", signRes.data.timestamp);

          const res = await axios.post(authorUploadUrl, authorFormData);
          authorImageUrl = res.data.secure_url;
        }

        // ✅ Now send form data to backend
        const formData = new FormData();
        formData.append("author_id", form.author_id);
        formData.append("title", form.title);
        formData.append("description", form.description);
        formData.append("content", form.content);
        formData.append("authorName", form.author);
        formData.append("language", form.language);
        formData.append("readingTime", "");
        formData.append("category", "");
        formData.append("authorUsername", form.author);
        formData.append("authorRole", form.usertitle);
        formData.append("designation", form.designation);
        formData.append("authorProfileUrl", form.profileUrl);
        formData.append("userdescription", form.userdescription);
        formData.append("href", "");

        if (blogImageUrl) formData.append("blogImage", blogImageUrl);
        if (authorImageUrl) formData.append("authorImageUrl", authorImageUrl);

        await axios.put(`/blog/${post_id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        });

        stopLoading();
        alert("Blog updated successfully!");
        navigate(`${getBasePath()}/blog`);
      } catch (error) {
        stopLoading();
        console.error(
          "Error updating blog:",
          error.response?.data || error.message
        );
        alert("Error updating blog. Please try again later.");
      }
    }
  };

  if (!post) {
    return (
      <div>
        {languagePrefix === "/nl"
          ? "Helaas, deze blogpost bestaat niet"
          : languagePrefix === "/de"
          ? "Leider gibt es diesen Blogbeitrag nicht"
          : "Unfortunately, the blogpost you were searching for does not exist"}
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  const handleDelete = async (id) => {
    const confirmMessage = "Do you want to delete this blog?";

    if (window.confirm(confirmMessage)) {
      try {
        await axios.delete(`/blog/${id}`);

        navigate(`${getBasePath()}/edit/blog`);
      } catch (error) {
        console.error("Error updating blog visibility:", error);
      }
    }
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
    resize: {
      locale: {},
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "clean",
  ];

  return (
    <>
      <Container pt={50}>
        {loading && (
          <div className={classes.loadingOverlay}>
            <Text size="xl" weight={700}>
              Saving...
            </Text>
            <Progress
              value={progress}
              size="xl"
              color="blue"
              mt="md"
              w="300px"
            />
            <Text size="lg" mt="sm">
              {progress}%
            </Text>
          </div>
        )}
        {/* <span
              onClick={() => setEditBlog(true)}
              style={{ cursor: "pointer" }}
            >
              <BsPencil size="25px" />
            </span> */}
        {!editBlog ? (
          <Container>
            <Container pt={100}>
              <span
                onClick={() => setEditBlog(true)}
                style={{ cursor: "pointer" }}
              >
                <BsPencil size="25px" />
              </span>
              <span
                onClick={() => handleDelete(post.id)}
                style={{ cursor: "pointer", marginLeft: "10px" }}
              >
                <BsTrash size="25px" />
              </span>

              <Title
                order={4}
                weight={200}
                align="left"
                color="resirent"
                mb="md"
              >
                {post?.date && formatDate(post?.date)}
              </Title>

              <Title order={1} align="left" mt="md">
                {title}
              </Title>
              <Text
                c="dimmed"
                className={classes.description}
                align="left"
                mt="md"
              >
                {description}
              </Text>
            </Container>

            {/* show the button if showScrollButton is true => Still to do */}

            <Container pt="md">
              <div dangerouslySetInnerHTML={{ __html: post?.content }} />
            </Container>
            <Container mb="md">
              <Group noWrap>
                <Avatar src={post?.author?.imageUrl} size={128} radius="md" />
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Text pr="md" fz="xs" tt="uppercase" fw={700} c="dimmed">
                      {post?.author?.designation}
                    </Text>
                    <ActionIcon
                      component="a"
                      href={
                        post?.author?.profileUrl?.startsWith("http")
                          ? post?.author?.profileUrl
                          : `https://${post?.author?.profileUrl}`
                      }
                      color="resirent"
                      variant="outline"
                      key={post?.author?.title}
                      size={28}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconBrandLinkedin size="1.4rem" stroke={1.5} />
                    </ActionIcon>
                  </div>

                  <Text fz="lg" fw={500} className={classes.name}>
                    {post?.author?.title}
                  </Text>

                  <Group noWrap spacing={10} mt={5}>
                    <Text fz="xs" c="dimmed">
                      {post?.author?.description}
                    </Text>
                  </Group>
                </div>
              </Group>
            </Container>
          </Container>
        ) : (
          <Container className={classes.cardMain} size="lg" mt="xl">
            <Card shadow="sm" className={classes.card} radius="md" withBorder>
              <form onSubmit={handleSubmit}>
                <Grid align="center" gutter="md">
                  {/* Title Input */}
                  <Grid.Col span={3}>
                    <Text className={classes.label}>Title</Text>
                  </Grid.Col>
                  <Grid.Col span={9}>
                    <TextInput
                      placeholder="Enter blog title"
                      value={form.title}
                      onChange={handleChange}
                      name="title"
                      error={errors.title}
                    />
                  </Grid.Col>

                  {/* Image Upload */}
                  <Grid.Col span={3}>
                    <Text className={classes.label}>Main Image Upload</Text>
                  </Grid.Col>
                  <Grid.Col span={9}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                    />
                     {imagePreview && (
                    <Box mt="md">
                      <Image src={imagePreview} alt="Preview" height={200} />
                        <Button color="red" mt="sm" onClick={removeImage}>
                          Remove Image
                        </Button>
                      </Box>
                    )}
                  </Grid.Col>

                  {/* Content Editor */}
                  <Grid.Col span={3}>
                    <Text className={classes.label}>Content</Text>
                  </Grid.Col>
                  <Grid.Col className={classes.texteditor} span={9}>
                    <ReactQuill
                      value={form.content}
                      onChange={handleEditorChange}
                      modules={modules}
                      formats={formats}
                      className={classes.editor}
                    />
                  </Grid.Col>

                  <Grid.Col span={3}>
                    <Text className={classes.label}>Author Name</Text>
                  </Grid.Col>
                  <Grid.Col span={9}>
                    <TextInput
                      placeholder="Enter Author Name"
                      value={form.usertitle}
                      onChange={handleChange}
                      name="usertitle"
                      error={errors.usertitle}
                    />
                  </Grid.Col>
                  <Grid.Col span={3}>
                    <Text className={classes.label}>Author Designation</Text>
                  </Grid.Col>
                  <Grid.Col span={9}>
                    <TextInput
                      placeholder="Enter Author Designation"
                      value={form.designation}
                      onChange={handleChange}
                      name="designation"
                      error={errors.designation}
                    />
                  </Grid.Col>
                  <Grid.Col span={3}>
                    <Text className={classes.label}>Author Profile Url</Text>
                  </Grid.Col>
                  <Grid.Col span={9}>
                    <TextInput
                      placeholder="Enter Author Profile Url"
                      value={form.profileUrl}
                      onChange={handleChange}
                      name="profileUrl"
                      // error={errors.designation}
                    />
                  </Grid.Col>

                  <Grid.Col span={3}>
                    <Text className={classes.label}>Author Image</Text>
                  </Grid.Col>
                  <Grid.Col span={9}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleUserImageUpload}
                    />
                    {userImagePreview && (
                      <Box>
                        <Image
                          src={userImagePreview}
                          alt="Preview"
                          height={200}
                        />
                        <Button color="red" mt="sm" onClick={removeUserImage}>
                          Remove Image
                        </Button>
                      </Box>
                    )}
                  </Grid.Col>

                  <Grid.Col span={3}>
                    <Text className={classes.label}>Author Description</Text>
                  </Grid.Col>
                  <Grid.Col span={9}>
                    <Textarea
                      rows={6}
                      placeholder="Enter Author Description"
                      value={form.userdescription}
                      onChange={handleChange}
                      name="userdescription"
                      // error={errors.designation}
                    />
                  </Grid.Col>
                </Grid>

                <Group position="right" mt="lg">
                  <CancelButton
                    buttonText="Cancel"
                    onClick={() => setEditBlog(false)}
                  />

                  <SaveButton
                    buttonText="Save"
                    onClick={() => {}}
                    type="submit"
                    // enabled={uploadLegal}
                  />
                </Group>
              </form>
            </Card>
          </Container>
        )}
      </Container>

      {/* Share your opinion */}
      {/*} <p className = "mt-6 text-sm text-gray-500 text-justify">
Have you found other solutions or have additional suggestions? 
Please share them with us by using the form below!
</p> */}
    </>
  );
}
